<template>
  <div class="main">
    <img v-if="!loading && !isDarkMode" src="@/assets/images/clink-wide-text.png" class="top-logo">
    <img v-if="!loading && isDarkMode" src="@/assets/images/clink-wide-text-white.png" class="top-logo">
    <div class="enter-group" v-if="!loading && step === 0">
      <div>
        <h2>Du bist noch kein Mitglied bei einer Gruppe.</h2>
        <p>Was möchtest du tun?</p>
      </div>
      <div class="action_choice">
        <button @click="step = 'create_group'"><img src="@/assets/images/group_add.svg">Gruppe erstellen</button>
        <button @click="step = 'join_group'"><img src="@/assets/images/group.svg">Gruppe beitreten</button>
      </div>
    </div>

    <div class="enter-group" v-if="step === 'create_group'">
      <button class="back_button" @click="step = 0"><img src="@/assets/images/back.svg">Zurück</button>
      <h2>Erstelle jetzt deine Gruppe</h2>
      <p class="limit-hint">Kostenlose Gruppen sind auf 5 Mitglieder begrenzt.</p>
      <form v-on:submit.prevent="createPool">
       <div class="form-item">
         <label for="new_group_name">Gruppenname</label>
         <input type="text" id="new_group_name" v-model="newGroupName">
       </div>
      <div class="form-item center">
        <button type="submit">Erstellen</button>
      </div>
      </form>
    </div>
    <div class="enter-group" v-if="step === 'join_group'">
      <button class="back_button" @click="step = 0"><img src="@/assets/images/back.svg">Zurück</button>
      <h2>Gruppe beitreten</h2>
      <form v-on:submit.prevent="joinPool">
        <div class="form-item">
          <label for="new_group_name">Einladungs-Code</label>
          <input type="text" id="new_group_name" v-model="inviteCode" placeholder="Z.B. ABCDE">
          <QRScanner @scan="onQRScanned" />
          <p class="error" v-if="errorMsg">{{errorMsg}}</p>
        </div>
        <div class="form-item center">
          <button type="submit">Beitreten</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import QRScanner from "@/components/QRScanner.vue";
export default {
  "name": "HomeView",
  components: { QRScanner },
  data() {
    return {
      isAdmin: false,
      isNew: false,
      step: 0,
      isDarkMode: document.documentElement.getAttribute('data-theme') === 'dark',
      newGroupName: null,
      inviteCode: null,
      errorMsg: null,
      loading: true
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    async createPool() {
      this.msg = await AuthService.createPool({"new_group_name": this.newGroupName});
      if (this.msg.success) {
        const poolMsg = await AuthService.getPool({pool_id: this.msg.newPoolId});
        if (poolMsg.success) {
          this.$store.commit('SET_SELECTED_POOL', poolMsg.msg);
        }
        this.$router.push('/pool-settings?pool=' + this.msg.newPoolId)
      } else {
        this.msg = this.msg.msg
      }
    },
    async joinPool() {
      try {
        this.msg = await AuthService.joinPool({"invite_code": this.inviteCode.toUpperCase()});
        if (this.msg.success) {
          const poolMsg = await AuthService.getPool({pool_id: this.msg.newPoolId});
          if (poolMsg.success) {
            this.$store.commit('SET_SELECTED_POOL', poolMsg.msg);
          }
          this.$router.push('/pool-settings?pool=' + this.msg.newPoolId)
        } else {
          this.msg = this.msg.msg
          console.log(this.msg)
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    },
    onQRScanned(code) {
      this.inviteCode = code;
      this.joinPool();
    },
    async getJoinedPools() {
      console.log("getting joined pools")
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.$router.push("/match")
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
    }
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isNew = !!this.msg.msg.isNew;
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }
    // Check for pending invite from JoinView
    const pendingCode = localStorage.getItem('pending_invite_code');
    if (pendingCode) {
      this.inviteCode = pendingCode;
      await this.joinPool();
      localStorage.removeItem('pending_invite_code');
    }

    await this.getJoinedPools();
    this.loading = false;
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 40px 20px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 40px;
}

h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 10px 0;
}

p {
  color: var(--tertiary-color);
  margin-bottom: 20px;
}

.limit-hint {
  font-size: 0.85rem;
  font-style: italic;
  margin-top: 2px;
}

.top-logo {
  max-height: 80px;
}

.enter-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background); /* or white */
  border: 1px solid var(--border-color);
  border-radius: var(--radius-l);
  padding: 30px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
}

.enter-group form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.enter-group input {
  font-size: 1.2rem;
  border: none;
  border-radius: var(--radius-m);
  padding: 15px;
  background-color: var(--background-secondary);
  color: var(--primary-color);
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.enter-group input:focus {
  outline: 2px solid var(--primary-color);
  background: var(--background);
}

.enter-group input::placeholder {
  color: var(--tertiary-color);
}

.form-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.form-item label {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--secondary-color);
  margin-left: 5px;
}

.action_choice {
  display: flex;
  gap: 15px;
  width: 100%;
}

.action_choice button {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  background: var(--background-secondary);
  border-radius: var(--radius-l);
  color: var(--primary-color);
  font-weight: 600;
  text-align: center;
  transition: background 0.2s;
  padding: 20px;
}

.action_choice button:active {
  background: var(--active-bg);
  transform: scale(0.98);
}

.action_choice button img {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
  filter: var(--icon-filter);
}

button[type=submit] {
  background: var(--primary-color);
  color: var(--background-secondary);
  width: 100%;
  padding: 16px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: var(--radius-l);
  margin-top: 10px;
  transition: opacity 0.2s;
}

button[type=submit]:active {
  opacity: 0.8;
}

.back_button {
  background: none;
  padding: 0;
  color: var(--primary-color);
  align-self: flex-start;
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-bottom: 20px;
}

.back_button img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  filter: var(--icon-filter);
}
</style>
